import * as React from "react";
import { Box, Typography, Chip, type ChipProps } from "@mui/material";

interface EnvironmentCardProps {
  environment: string | null | undefined;
}

const COLOR_MAP: Record<string, ChipProps["color"]> = {
  production: "error",
  staging: "warning",
  development: "info",
  test: "default",
};

/** Small, visually distinct environment indicator - color-coded so "production" stands out from "development". */
export function EnvironmentCard({ environment }: EnvironmentCardProps): React.JSX.Element {
  const normalized = (environment ?? "unknown").toLowerCase();
  const color = COLOR_MAP[normalized] ?? "default";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Typography variant="caption" color="text.secondary">
        Environment
      </Typography>
      <Chip size="small" label={environment ?? "unknown"} color={color} />
    </Box>
  );
}
